export default __webpack_public_path__ + "static/media/036-to do list.b432367d.svg";